module.exports = "/_next/static/images/4abdb03d4f9f43f48258f2c9178abab8-2-women-working-landscape@3x.jpg";